module.exports = __webpack_public_path__ + "img/cb-f-r-rr2.e68aa3aa.gif";